const isAuthEnabled = () => {
  return window.config.auth.enabled;
}

export default isAuthEnabled;
